var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "community-dynamics-tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": _vm.handleTabClick,
            "tab-remove": _vm.handleTabRemove,
          },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "社区动态", name: "communityDynamics" } },
            [
              _vm.activeTab === "communityDynamics"
                ? _c("community-dynamics-list", {
                    on: { "view-detail": _vm.handleViewDetail },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "赞排行", name: "praiseRank" } },
            [
              _vm.activeTab === "praiseRank"
                ? _c("praise-rank-list", {
                    on: { "view-detail": _vm.handleViewDetail },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.detailTabs, function (item) {
            return _c(
              "el-tab-pane",
              {
                key: item.name,
                attrs: { label: item.title, name: item.name, closable: "" },
              },
              [
                _c("community-dynamics-detail", {
                  attrs: { "detail-data": item.detailData, type: item.type },
                  on: {
                    "go-back": function ($event) {
                      return _vm.handleDetailGoBack(item.name)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }